import React from 'react';
import './DotLoader.css';


const dots = (
  <div className="DotLoader">
    <ul className="DotLoader-ul">
      <li className="DotLoader-li" />
      <li className="DotLoader-li" />
      <li className="DotLoader-li" />
    </ul>
  </div>
);


export default function DotLoader() {
  return dots;
}



// WEBPACK FOOTER //
// ./src/modules/DotLoader/index.js